import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css';
import 'vant/lib/index.css';
import { index } from './utils';
import { Uploader } from 'vant';

import Axios from 'axios';
Vue.use(Uploader);
Vue.use(VueAwesomeSwiper);
Vue.prototype.$axios = Axios;
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$utils = index;
Vue.use(ElementUI);
// 根据环境设置不同的服务地址，自己开发的时候改成development,打包发布时候改成production
if (process.env.NODE_ENV === 'production') {
  // 为生产环境修改配置...

  // ll
  Vue.prototype.$baseUrl = 'https://x6.goeasy.cn/cli/client/';
  // axios.defaults.url = Vue.prototype.$baseUrl;
  Vue.prototype.$loginUrl = 'https://base.goeasy.cn/login/';
  Vue.prototype.$userMangerUrl = 'https://x6.goeasy.cn/user/';
  Vue.prototype.$builderUrl = 'https://x6.goeasy.cn/third';

  // x6
  /*  Vue.prototype.$baseUrl = 'https://x6.goeasy.cn:8080/cli/client/';
  // axios.defaults.url = Vue.prototype.$baseUrl;
  Vue.prototype.$loginUrl = 'https://model.goeasy.cn:8301/';
  Vue.prototype.$userMangerUrl = 'https://model.goeasy.cn:8201/'; */

  // k8s
  /*  Vue.prototype.$baseUrl = 'https://x6k8s.goeasy.cn/cli/client/';
  // axios.defaults.url = Vue.prototype.$baseUrl;
  Vue.prototype.$loginUrl = 'https://x6k8s.goeasy.cn/login/';
  Vue.prototype.$userMangerUrl = 'https://x6k8s.goeasy.cn/user/'; */

  // 华砼
/*  Vue.prototype.$baseUrl = 'https://huatong.goeasy.cn/x6client/client/';
  Vue.prototype.$loginUrl = 'https://huatong.goeasy.cn:8301/';
  Vue.prototype.$userMangerUrl = 'https://huatong.goeasy.cn:8201/'; */
} else {
  // 为开发环境修改配置...
  Vue.prototype.$baseUrl = '';
  Vue.prototype.$loginUrl = '';
  Vue.prototype.$userMangerUrl = '';
  Vue.prototype.$builderUrl = '';
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
